module.exports = __webpack_public_path__ + "img/img_warning.014b5c3d.png";